<template>
  <v-app>
    <slot />
  </v-app>
</template>

<script setup lang="ts"></script>
